import { render, staticRenderFns } from "./roleSetting.vue?vue&type=template&id=41a7ff3e&scoped=true"
import script from "./roleSetting.vue?vue&type=script&lang=js"
export * from "./roleSetting.vue?vue&type=script&lang=js"
import style0 from "./roleSetting.vue?vue&type=style&index=0&id=41a7ff3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a7ff3e",
  null
  
)

export default component.exports